import { get, post, remove, postReturnResponse, put } from "../api_helper";
import * as url from "../url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getDeleteDocument = (payload) => remove(baseURL + (payload?.applicationName === 'Benefits' ? url?.BENEFIT_DELETE_DOCUMENT : url.DELETE_DOCUMENT) + "/" + payload?.payload);

export const getDocumentRequiredFields = (id, applicationName) => get(`${baseURL + (applicationName == 'Benefits' ? (url.BenefitLkDocumentSourceById + id) : `${url.LkDocumentSource}/${id}`)}   `);
export const getDocumentSources = ({ applicationName = null }) => get(`${baseURL + (applicationName === 'Benefits' ? url.BenefitLkDocumentSource : url.LkDocumentSource)}`);
export const postDocumentsAPI = (payload) => {
  return post(baseURL + (payload?.applicationName === 'Benefits' ? url.BenefitspostDocuments : url.postDocuments), payload);
}

export const verifyDocumentAPI = (payload) => {
  put(baseURL + (payload?.payload?.applicationName === 'Benefits' ? url.BenefitverifyDocument : url.verifyDocument), payload?.payload);

}
// export const onCombineDocumentsAPI=(payload) =>
// post(baseURL + url.combinedDocument, payload);
export const onCombineDocumentsAPI = (payload) => {
  const { fileExtension, headername, ...rest } = payload;
  return postReturnResponse(
    baseURL +
    url?.combinedDocument,
    // +
    // `/${payload.isOJA ? 'OJAExport' : 'CommonSearchExport'}?fileExtension=pdf${headername?'&headername=header':""}`,
    payload,
    { responseType: "blob" }
  );
};

export const moveDocumentsToPRAPI = (payload) =>
  post(baseURL + url.moveDocumentToPR, payload);